import axios from 'axios';
import { useQuery } from 'react-query';
import { normalizeJSONAPIResponse } from 'utils/modelUtils';

interface SetsResponse {
  data: any[];
  meta: {
    totalCount: number;
    totalPages: number;
  };
}

const getSets = async (
  partnerId: string,
  includeCourseRelations: boolean = false,
  pageNumber: number = 1,
  pageSize: number = 25,
  sortParam: string = '-updated_at',
  searchName: string = ''
): Promise<SetsResponse> => {
  const endpoint = `/api/v3/partner/${partnerId}/sets`;

  let queryParams = `include=image,creator,courses&sort=${sortParam}&page[number]=${pageNumber}&page[size]=${pageSize}`;
  if (includeCourseRelations) {
    queryParams += `&include_course_relations=true`;
  }
  if (searchName) {
    queryParams += `&name=${encodeURIComponent(searchName)}`;
  }
  const response = await axios.get(`${endpoint}?${queryParams}`);
  const normalizedData = normalizeJSONAPIResponse(response.data);
  return {
    data: normalizedData,
    meta: response.data.meta,
  };
};

export const useGetSets = (
  partnerId: string,
  includeCourseRelations: boolean = false,
  pageNumber: number = 1,
  pageSize: number = 25,
  sortParam: string = '-updated_at',
  searchName: string = ''
) => {
  return useQuery(
    ['sets', partnerId, includeCourseRelations, pageNumber, pageSize, sortParam, searchName],
    () => getSets(partnerId, includeCourseRelations, pageNumber, pageSize, sortParam, searchName),
    {
      enabled: !!partnerId,
      keepPreviousData: true,
    }
  );
};
